import { formatNumber } from './scale'
import styles from './charts.module.css'

export type HBar = { readonly key: string; readonly label: string; readonly value: number; readonly note?: string }

export function HBars({ items, color, label }: { items: readonly HBar[]; color: string; label: string }) {
  const max = Math.max(1, ...items.map((i) => i.value))
  return (
    <ul className={styles.hbars} aria-label={label}>
      {items.map((item) => (
        <li key={item.key} className={styles.hbar}>
          <div className={styles.hbarHead}>
            <span>{item.label}</span>
            <span className={styles.hbarValue}>
              {formatNumber(item.value)}
              {item.note && <span className="muted"> · {item.note}</span>}
            </span>
          </div>
          <div className={styles.hbarTrack}>
            <div className={styles.hbarFill} style={{ width: `${(item.value / max) * 100}%`, background: color }} />
          </div>
        </li>
      ))}
    </ul>
  )
}
